export default __webpack_public_path__ + "src/images/packages/maison-de-plage/847fe74fe5e6cd32f99cdb59a0c2e78b-4.jpg";